export const DOMAIN_TYPE = 'data';
